import type { CustomerData } from '@components/chat/forms/CustomerDataForm'
import type { VehicleData } from '@components/chat/forms/VehicleDataForm'

export function formatCustomerChatLine(data: CustomerData): string {
  const parts: string[] = [data.name.trim()]
  if (data.email.trim()) parts.push(`email ${data.email.trim()}`)
  if (data.phone.trim()) parts.push(`telefone ${data.phone.trim()}`)
  if (data.nif.trim()) parts.push(`NIF ${data.nif.trim()}`)
  return parts.join(', ')
}

export function formatVehicleChatLine(data: VehicleData): string {
  const parts: string[] = [data.matricula.trim().toUpperCase()]
  if (data.marca.trim()) parts.push(data.marca.trim())
  if (data.modelo.trim()) parts.push(data.modelo.trim())
  if (data.ano.trim()) parts.push(data.ano.trim())
  if (data.km.trim()) parts.push(`${data.km.trim()} km`)
  if (data.combustivel.trim()) parts.push(data.combustivel.trim().toLowerCase())
  if (data.ultimaInspecao?.trim()) {
    parts.push(`última inspeção ${data.ultimaInspecao.trim()}`)
  }
  return parts.join(', ')
}
